import React, { useEffect, useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { notification } from "../../assets/images";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardType,
  setShowSmSidebar,
} from "../../redux/slices/dashboardSlice";
import { useLazyQuery } from "@apollo/client";
import { GET_USER_DETAILS } from "../../apollo/operations";
import { setUserDetails } from "../../redux/slices/userSlice";
import { showToast } from "../../utils/showToast";
import { checksumAddress } from "viem";
import Select from "react-select";
import { dashboardMenu } from "../../constants/dashboardMenu";
import { IoCarOutline } from "react-icons/io5";
import { BiChevronDown } from "react-icons/bi";

type NavbarProps = {
  active: string;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSidebar: () => void;
  data: any;
  open: () => void;
};

const Navbar: React.FC = () => {
  const user = useSelector((state: any) => state.user.userDetails);

  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [walletAddress, setWalletAddress] = useState("");

  const handleSelect = (e: any) => {
    setDashboardType(e);
    console.log(e);
  };

  const getWalletFromIndexedDB = async (): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const indexedDB =
        window.indexedDB ||
        (window as any).mozIndexedDB ||
        (window as any).webkitIndexedDB ||
        (window as any).msIndexedDB ||
        (window as any).shimIndexedDB;

      const request = indexedDB.open("ec_wallets", 1);

      request.onerror = function (event) {
        console.log("error: ");
        // console.error(event);
      };

      request.onupgradeneeded = function (event) {
        const db = request.result;
        const store = db.createObjectStore("ec_wallets", {
          keyPath: "address",
        });
      };

      request.onsuccess = function (event) {
        const db = request.result;
        const tx = db.transaction("ec_wallets", "readwrite");
        const store = tx.objectStore("ec_wallets");
        const getRequest = store.getAll();

        getRequest.onerror = function (event) {
          console.log("error: ");
          // console.error(event);
        };

        getRequest.onsuccess = function (event) {
          // console.log("success");
          // console.log(getRequest.result);
          resolve(getRequest.result);
        };

        tx.oncomplete = function () {
          db.close();
        };
      };
    });
  };

  const userID = window.localStorage.getItem("user");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [lazyGetUserDetails, { loading, error, data }] = useLazyQuery(
    GET_USER_DETAILS,
    {
      variables: {
        where: {
          id: userID as string,
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        // console.log(data.user);
        dispatch(setUserDetails(data.user));
      },
      onError: (error) => {
        // console.log(error);

        showToast(error.message, "error");
        // navigate("/auth");
      },
    }
  );

  const [isOpen, setIsOpen] = useState(false);
  const showSmSidebar = useSelector(
    (state: any) => state.dashboardState.showSmSidebar
  );

  function toggleSidebar() {
    dispatch(setShowSmSidebar(!showSmSidebar));
  }

  const path = useLocation().pathname.split("/")[2];
  // console.log(path);

  const type: "lessor" | "lessee" = useSelector(
    (state: any) => state.dashboardState.dashboardType
  );

  useEffect(() => {
    if (!user) {
      lazyGetUserDetails();
    }
  }, [user]);

  useEffect(() => {
    async function getWallet() {
      const wallets = await getWalletFromIndexedDB();

      if (wallets?.length > 0) {
        // showToast("Generated wallet found. Processing...", "info");
        // console.log(wallets[0]?.address);

        setWalletAddress(checksumAddress(wallets[0]?.address));
        // setDbWallet(wallets[0]);
        // setIsGeneratedWallet(true);
        return;
      }
    }

    getWallet();
  }, []);

  return (
    <div className="w-full bg-white border-t border-t-[#E5E5E5] overflow-scroll hide-scrollbar hide-scrollbar::-webkit-scrollbar pb-10">
      <div className="flex w-full md:w-[80%]  mx-auto justify-between items-center py-4 ">
        <div className="flex items-center">
          {dashboardMenu
            .filter((menu) => !(type === "lessee" && menu.link === "reviews"))
            .map((menu, index) => (
              <div
                className={`flex items-center gap-2 p-4 cursor-pointer ${
                  path === menu.link ? "bg-[#CFF1E6] rounded-[4px]" : ""
                } ${!path && !menu.link ? "bg-[#CFF1E6] rounded-[4px]" : ""} `}
                key={index}
                onClick={() => {
                  // console.log(path, menu.link);
                  if (
                    (menu.link === "profile" || menu.link === "payments") &&
                    user?.userOnboardingStatus !== "VerifyDriverLicense"
                  ) {
                    showToast(
                      "Please complete your ID Verification to view your profile",
                      "error"
                    );
                    return;
                  }

                  navigate(`/dashboard/${menu.link}`);
                }}
              >
                <menu.icon className=" text-midGreen text-[12px] lg:text-[20px]" />
                <p className="text-midGreen font-Poppins text-[9px] lg:text-[14px] font-medium  ">
                  {menu.name}
                </p>
              </div>
            ))}
        </div>
        <div
          className=" cursor-pointer relative w-fit hidden md:flex "
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {type === "lessee" ? (
            <div className="flex  gap-2 cursor-pointer items-center rounded-[20px] bg-[#FFE75C] p-4 max-w-fit">
              <AiOutlineUser size={16} className="text-[#33363F]" />
              <p className="text-black font-Poppins text-[20px] font-medium leading-5">
                Lessee
              </p>
              <BiChevronDown size={20} className="text-[#33363F]" />
            </div>
          ) : (
            <div className="flex  gap-2 cursor-pointer items-center rounded-[20px] bg-[#263238] p-4 max-w-fit">
              <IoCarOutline size={16} className="text-[#FFE75C]" />
              <p className="text-[#FFE75C] font-Poppins text-[20px] font-medium leading-5">
                Lessor
              </p>
              <BiChevronDown size={20} className="text-[#FFE75C]" />
            </div>
          )}
          {showDropdown && (
            <div className="absolute top-10 right-0 h-[60px] flex justify-center items-center border shadow-lg shadow-midGreen  z-50 bg-white rounded-[12px] px-4 py-4  max-w-fit ">
              {type !== "lessee" ? (
                <div
                  className="flex gap-2 h-full cursor-pointer items-center w-full"
                  onClick={() => {
                    // console.log("lessee");
                    dispatch(setDashboardType("lessee"));
                  }}
                >
                  <AiOutlineUser size={16} className="text-[#19B375]" />
                  <p className="text-[#19B375] font-Poppins text-[20px] font-medium leading-5 w-full whitespace-nowrap">
                    Lessee Dashboard
                  </p>
                </div>
              ) : (
                <div
                  className="flex gap-2 h-full cursor-pointer items-center w-full"
                  onClick={() => {
                    // console.log("lessor");
                    dispatch(setDashboardType("lessor"));
                  }}
                >
                  <IoCarOutline size={16} className="text-[#19B375]" />
                  <p className="text-[#19B375] font-Poppins text-[20px] font-medium leading-5 w-full whitespace-nowrap">
                    Lessor Dashboard
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
    // <div className="w-full flex justify-center border-b border-[#EBE1EB] bg-white py-5 sticky top-0 z-50">
    //   <div className="w-[90%] flex justify-between items-center">
    //     <div className="flex gap-5 items-center">
    //       <div className="flex  lg:hidden">
    //         {/* Hamburger button */}
    //         <div className=" cursor-pointer" onClick={toggleSidebar}>
    //           {showSmSidebar ? (
    //             <AiFillCloseCircle size={30} />
    //           ) : (
    //             <AiOutlineMenu size={30} />
    //           )}
    //         </div>
    //       </div>

    //       <p className="text-black font-Poppins text-[20px] font-bold  ">
    //         {capitalizeWords(path) ?? "Dashboard"}
    //       </p>
    //     </div>

    //     <div className="flex gap-3 items-center ">
    //       <Select
    //         value={dashboardType}
    //         defaultValue={dashboardType}
    //         placeholder={dashboardType}
    //         options={options[0].options}
    //         isMulti={false}
    //         className="w-48 text-white bg-midGreen border rounded-lg"
    //         isSearchable={false}
    //         onChange={handleSelect}
    //       />

    //       <img src={notification} alt="" />
    //       <Link
    //         to="/dashboard"
    //         className="flex justify-center items-center gap-2 cursor-pointer"
    //       >
    //         <p className="text-lightGreen text-center font-Inter font-medium leading-6 text-[16px] p-2 bg-darkGreen rounded-full">
    //           {user?.username?.slice(0, 2)?.toUpperCase()}
    //         </p>
    //         <p className="text-midGreen first-letter:capitalize font-Poppins text-[16px] font-normal leading-5 ">
    //           {user?.username}
    //         </p>
    //       </Link>
    //       <MdArrowDropDown color="black" size={25} />

    //       <div className=" hidden lg:block bg-midGreen border rounded-lg ">
    //         {/* <Web3Button icon="hide" balance="show" /> */}
    //         {walletAddress ? (
    //           <div className="p-2 text-white text-base">
    //             {walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}
    //           </div>
    //         ) : (
    //           <w3m-button balance="show" />
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Navbar;
